import useFlag from 'hooks/useFlag'
import { Fields as Merchant } from 'models/Merchant'
import { Col, Row } from 'react-bootstrap-five'
import { getDiscountCategories } from '../../helpers'
import { RedeemTypeItem } from '../../types'
import Category from './Category'

type TypeStepProps = {
  merchant: Merchant | null
  typeItem: RedeemTypeItem | null
  setRedeemType: (typeItem: RedeemTypeItem) => void
}

const TypeStep = ({ merchant, typeItem, setRedeemType }: TypeStepProps) => {
  const categories = getDiscountCategories(!!merchant?.ordering_enabled)
  const freeModifierRewardsEnabled = useFlag('mx-free-modifier-rewards', false)

  // Hide 'Get a free modifier' if the feature is disabled
  if (!freeModifierRewardsEnabled) {
    const freeItemCategory = categories.find(({ key }) => key === 'free_item')
    freeItemCategory?.items &&
      (freeItemCategory.items = freeItemCategory.items.filter(
        ({ key }) => key !== 'get_a_free_modifier'
      ))
  }

  return (
    <Row className="d-flex justify-content-center">
      <Col lg={6}>
        {categories.map(redeemCategory => (
          <Category
            key={redeemCategory.key}
            redeemCategory={redeemCategory}
            selectedTypeItem={typeItem}
            onItemSelect={setRedeemType}
          />
        ))}
      </Col>
    </Row>
  )
}

export default TypeStep
